module.exports = __webpack_public_path__ + "pc/img/developer.8110bb44.webp";